module.exports = __webpack_public_path__ + "img/cardorah.29db7629.jpg";